import service from '@/middleware'

const typeApi = {

    /**
     * Obtener los tipos de equipos
     */
    async getAllForSelector () {
        const result = await service.http.get(`/api/type/all-for-selector`)
        return result
    },

    /**
     * Obtener los tipos de equipo de una empresa y una actividad
     */
    async getAllForSelectorByEnterpriseIdAndActivityId(enterpriseId, activityId) {
        const result = await service.http.get(`/api/type/for-selector/enterprise/${enterpriseId}/activity/${activityId}`)
        return result
    },

}

export default typeApi
